import { Box, Typography } from '@mui/material'
import iconAppStore from 'assets/mobile/app_store.png'
import iconPlayStore from 'assets/mobile/play_store.png'
import iconDesktop from 'assets/mobile/desktop_windows.png'
import iconPhone from 'assets/mobile/phone_android.png'
import { getOperatingSystem } from 'utils/helper'

import './index.css'

const EmailVerifiedMob = () => {
  const isMac = getOperatingSystem(window)?.toLowerCase()?.includes('mac')
  return (
    <Box
      padding="30px"
      height="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      display="flex"
      color="#66668F"
      marginTop="46px"
      textAlign="center"
    >
      <Typography variant="h6" margin="40px 0px 15px 0px" color="#0A78CD">
        Your account has been successfully created!
      </Typography>
      <Box borderBottom="1px solid #CEE4F5">
        <Typography variant="body2" marginBottom="25px">
          We’re currently optimizing our mobile experience. Here’s what we suggest in the meantime.
        </Typography>
      </Box>
      <Box margin="46px 0px 26px 0px">
        <img style={{ cursor: 'pointer', marginBottom: '16px' }} src={iconPhone} width={40} alt="phone" />
        <Typography variant="body2">Download our mobile app to continue on your phone.</Typography>
      </Box>
      <Box>
        <img
          style={{ cursor: 'pointer' }}
          src={isMac ? iconAppStore : iconPlayStore}
          width={150}
          alt="mobilestore"
          onClick={() => {
            if (isMac) {
              window.open('https://apps.apple.com/us/app/markaaz/id1632920268', '_self')
            } else {
              window.open('https://play.google.com/store/apps/details?id=com.markaaz.dashboard&hl=en&gl=US')
            }
          }}
        />
      </Box>
      <Box marginTop="46px">
        <img style={{ cursor: 'pointer', marginBottom: '16px' }} src={iconDesktop} width={40} alt="phone" />
        <Typography variant="body2">Or, switch over to your computer to continue through the browser.</Typography>
      </Box>
    </Box>
  )
}
export default EmailVerifiedMob
